import BatchExecutionDetailsStorageManager from '@Services/BatchExecutionDetailsStorageManager';
import logoutAction from '@Actions/UserActions';
import each from 'lodash/each';
import ProfileSettings from '@Services/ProfileSettings';
import NavigationHistory from '@Services/NavigationHistory';
import SearchStorage from '@Services/SearchStorage';
import { clearRsBreadcrumbs } from '@Pages/RetroSynthesis/RsBreadcrumbs/RsBreadcrumbs';
import { clearRsSavedLocation } from '@Pages/RetroSynthesis/RetroSynthesisRoot/utils/rsSavedLocation';
import { dispatchClearCasNumbers as clearCasNumbersFromRedux } from '@Containers/CasNumber/actions';
import { removeStateFromStorage as clearCasNumbersFromStorage } from '@Containers/CasNumber/persistedState';

import RelativeContextService from '@Containers/RelativeContext/RelativeContextNgService';
import findPreparationsService from '@Containers/FindPreparations/FindPreparationsService';
import ResultsPreviewStorage from '@Services/AppDBStorage/Storages/ResultsPreviewStorage';
import TableColumnsSwitcherStorage from '@Services/AppDBStorage/Storages/TableColumnsSwitcherStorage';
import StructureEditorOptionsStorage from '@Services/AppDBStorage/Storages/StructureEditorOptionsStorage';
import StructureContainers from '@Services/StructureContainers';
import store from '@Store';
import MessageBroker from '@Services/MessageBroker';
import AppStorage from '@Services/AppStorage';
import { ZOOM_STORAGE_KEY } from '@Containers/Zoom/ZoomConstants';
import ExportReopenService from '@Services/ExportReopenService';
import { QUICK_SEARCH_CACHE_NAME } from '@Pages/QuickSearch/QuickSearchConstants';
import { PROJECTS_LIST_PAGE_SIZE_CACHE_KEY } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import RoutingConfig from '@Constants/rx-user/routing-config.provider';
import * as AuthUtils from './AuthUtils';
import * as AuthHelper from './AuthHelper';

const { userRoles } = RoutingConfig;

const DEFAULT_USER = {
  role: userRoles.public,
  history: {
    breadcrumbs: {},
    viewedResultsParams: {},
    recentSearches: [],
    savedSearches: [],
  },
};

const ADVANCED_QUERYLET_SELECTED_DB = 'advancedQueryletSelectedDB';

const STORAGE_TO_CLEAN = [
  'currentUser',
  'qbSearchSectionStates',
  'synthesisPlannerData',
  'previousResultPage',
  'qbSearchDB',
  'qbNodesList',
  'qbHiddenList',
  'heatmapSettings',
  'userInterface',
  ZOOM_STORAGE_KEY,
  'resultsPerPage',
  'viewedDataAA',
  'userNotifications',
  'qbPanelsStates',
  ExportReopenService.KEY,
  QUICK_SEARCH_CACHE_NAME,
  PROJECTS_LIST_PAGE_SIZE_CACHE_KEY,
  ADVANCED_QUERYLET_SELECTED_DB,
];

const cleanUp = () => {
  StructureContainers.removeAllContainers();

  // remove user data
  AuthHelper.setAccessToken(null);
  AuthUtils.updateUser(DEFAULT_USER, true);

  each(STORAGE_TO_CLEAN, (lsNamespace) => {
    AppStorage.instance.set(lsNamespace, '');
  });

  // changing it to hardClear will break after auth redirects ¯\_(ツ)_/¯
  NavigationHistory.softClear();
  ResultsPreviewStorage.clear();
  SearchStorage.clear();
  TableColumnsSwitcherStorage.clear();
  StructureEditorOptionsStorage.clear();
  BatchExecutionDetailsStorageManager.getInstance().clear();

  ProfileSettings.cleanUp();

  findPreparationsService.clearCache();
  RelativeContextService.clearSavedContexts();
  MessageBroker.cancelAll();

  // RS - clean-up on logout
  clearRsBreadcrumbs();
  clearRsSavedLocation();

  // CasNumber clean-up
  clearCasNumbersFromRedux();
  clearCasNumbersFromStorage();

  store.dispatch(logoutAction());

  return true;
};

export default cleanUp;
